<template>
  <div class="mapReminderVideo">
    <div class="reminderNameTitle" v-if="itemInfo">
      <div class="reminderName">
        {{ itemInfo.cameraName ? itemInfo.cameraName : "暂无数据" }}
      </div>
      <i
        class="iconfont icon-guanbi2"
        style="color: red"
        @click="closeReminder"
      ></i>
    </div>
    <div class="reminderDetail" v-if="itemInfo">
      <h4>
        设备状态: &nbsp;&nbsp;
        <span v-if="itemInfo.deviceLineStatus">{{
          itemInfo.deviceLineStatus == "0" ? "在线" : "离线"
        }}</span>
        <span v-else>{{ "--" }}</span>
      </h4>
      <h4>
        设备类型:&nbsp;&nbsp;<span v-if="itemInfo.cameraType">{{
          itemInfo.cameraType == "0"
            ? "枪机"
            : itemInfo.cameraType == "1"
            ? "球型"
            : "半球"
        }}</span>
        <span v-else>{{ "--" }}</span>
      </h4>

      <h4>
        IP地址:&nbsp;&nbsp;<span>{{
          itemInfo.cameraIpAddrs ? itemInfo.cameraIpAddrs : "--"
        }}</span>
      </h4>
      <h4>
        厂商编号:&nbsp;&nbsp;<span>{{
          itemInfo.otherId ? itemInfo.otherId : "--"
        }}</span>
      </h4>
    </div>
    <div class="operation">
      <el-button size="small" @click="clickOpenVideo(itemInfo)"
        >播放视频</el-button
      >
      <h-button size="small">加入搜索</h-button>
    </div>
    <h-video-dialog
      v-if="showVideoDialog"
      v-model:visible="showVideoDialog"
      :videoData="itemInfo"
      :title="videoTitle"
    ></h-video-dialog>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";

export default defineComponent({
  name: "mapReminderVideo",
  components: {},
  props: {
    itemInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup(props, context) {
    const data = reactive({
      showVideoDialog: false,
      videoDialogData: null,
      videoTitle: "",
    });
    const refData = toRefs(data);
    const closeReminder = () => {
      context.emit("close");
    };
    // 点击菜单
    const clickOpenVideo = (item) => {
      data.showVideoDialog = true;
      data.videoTitle = "实时视频";
    };
    return {
      ...refData,
      closeReminder,
      clickOpenVideo,
    };
  },
});
</script>
<style lang="scss" scoped>
.mapReminderVideo {
  width: 270px;
  height: 180px;
  background: rgba(8, 13, 38, 0.8);
  color: #14d1b3;
  background-size: 100% 100%;
  padding: 10px;
  font-size: 14px;
  border-radius: 10px;
  .reminderNameTitle {
    width: 100%;
    @include flex-row-sb-c;
    margin-bottom: 15px;
    i {
      cursor: pointer;
      // pointer-events: none;
    }
  }

  .reminderDetail {
    width: 100%;
    span {
      color: #fff;
    }
  }
  .reminderDetail ::after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border: 10px solid;
    border-color: transparent;
    border-top-color: rgba(8, 13, 38, 0.8);
    top: 100%;
    left: 50%;
    margin-left: -10px;
  }
  .operation {
    width: 100%;
    margin-top: 16px;
    @include flex-row-sa-c;
  }
}
</style>
